<template>
  <v-container fluid grid-list-xl>
    <span class="headline" v-if="country.id">{{ $t('editModel', { model: $tc('models.country', 1) }) }}</span>
    <span class="headline" v-else>{{ $t('createModel', { model: $tc('models.country', 1) }) }}</span>

    <v-form @submit.prevent="submit">
      <v-card class="mt-4">
        <v-card-text>
          <v-container fluid grid-list-md>
            <v-layout wrap>
              <v-flex xs12 sm12 md6>
                <v-select v-model="country.name"
                  :items="countries"
                  :label="$tc('models.country', 1)"
                  v-validate="'required'"
                  :error-messages="errors.collect('country')"
                  data-vv-name="country"
                  :data-vv-as="$tc('models.country', 1)"
                  required
                  ></v-select>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" flat @click="back" :loading="loading" :disabled="loading">{{ $t('cancel') }}</v-btn>
          <v-btn color="primary" dark :loading="loading" :disabled="loading" type="submit">{{ $t('save') }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-form>
  </v-container>
</template>

<script>
import Country from '@/client/country'

export default {
  name: 'CountryFormView',

  props: {},

  data () {
    return {
      loading: false,
      country: {},
      countries: []
    }
  },

  components: {
  },

  computed: {
  },

  methods: {
    async submit () {
      const isValid = await this.$validator.validateAll()
      if (!isValid) { return }

      this.loading = true
      try {
        await this.country.save()
        this.setNotification({
          color: 'success',
          message: this.$t('successfullySavedNotification')
        })
        this.back()
      } catch (err) {
        this.handleErr(err)
      }
      this.loading = false
    }
  },

  watch: {
  },

  async mounted () {
    this.country = new Country()

    this.countries = await this.country.getCountries()

    const id = this.$route.params.id
    if (id) {
      this.country = await Country.findOne(id)
    }
  }
}
</script>
